import React from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import GoogleMapLoader from 'react-google-maps-loader';
import GooglePlacesSuggest from 'react-google-places-suggest';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import 'CSS/main.scss';
import 'CSS/demand-supply/demand-supply.scss';
import { editProject, saveProject } from 'Actions/projectActions';
import { connect } from 'react-redux';
import { GOOGLE_API_KEY } from 'Api/Google';
import { geocodingAdapter } from '../../../../../../utils';
import { Formik } from 'formik';
import DatePicker from '../../CreateEditTicket/components/DatePicker';
import { createProjectSchema } from 'Validation';
import lightBlue from '@material-ui/core/colors/blueGrey';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';

const unit = [
  { id: 'square_meter', name: 'm2' },
  { id: 'square_feet', name: 'sq.ft.' },
];
const currency = [
  { id: 'GBP', name: 'GBP' },
  { id: 'USD', name: 'USD' },
  { id: 'EUR', name: 'EUR' },
  { id: 'AUD', name: 'AUD' },
  { id: 'CAD', name: 'CAD' },
  { id: 'JPY', name: 'JPY' },
  { id: 'CHF', name: 'CHF' },
];

class NewProjectDialog extends React.Component {
  state = {
    showHover: false,
    search: '',
    location: '',
    city: '',
    state: '',
    country: '',
    approximateGrossArea: '',
    approximateGrossAreaKey: '',
    approximateTotalBudget: '',
    approximateTotalBudgetKey: '',
    confidential: false,
    endDate: null,
    // projectUsage: '',
    projectUsageArea: '',
    projectUsageType: '',
    projectTitle: '',
    projectNumber: '',
    description: '',
  };

  componentDidMount() {
    if (this.props.project) {
      const {
        city,
        state,
        countryState,
        confidential,
        country,
        description,
        id,
        name,
        projectUsageId,
        projectUsageAreaId,
        projectUsageTypeId,
        uniqueProjectNumber,
        approxGrossArea,
        approxGrossAreaValue,
        approxTotalBudget,
        approxTotalBudgetValue,
        endDate,
      } = this.props.project;
      var _endDate = null;
      if (endDate) {
        var year = endDate.split('T')[0].split('-')[0];
        var month = endDate.split('T')[0].split('-')[1] - 1;
        var day = endDate.split('T')[0].split('-')[2];

        const date = new Date(year, month, day);
        _endDate = moment(date).format('YYYY MM DD');
      }
      this.setState({
        location: city,
        country: country,
        state: countryState,
        confidential,
        description,
        projectTitle: name,
        projectNumber: uniqueProjectNumber,
        // projectUsage: projectUsageId,
        projectUsageArea: projectUsageAreaId,
        projectUsageType: projectUsageTypeId,
        approximateGrossArea: approxGrossAreaValue,
        approximateGrossAreaKey: approxGrossArea,
        approximateTotalBudget: approxTotalBudgetValue,
        approximateTotalBudgetKey: approxTotalBudget,
        endDate: endDate ? _endDate : null,
      });
    }
  }

  handleInputChange = (setValues, values) => e => {
    setValues({ ...values, search: e.target.value, location: e.target.value });
  };

  handleSelectSuggest = (setValues, values) => geocodedPrediction => {
    var geocodeAdapterValue = geocodingAdapter(geocodedPrediction);
    setValues({
      ...values,
      search: '',
      location: geocodeAdapterValue.city,
      state: geocodeAdapterValue.stateCounty,
      country: geocodeAdapterValue.country,
    });
  };
  saveProject = data => {
    const {
      confidential,
      description,
      location,
      state,
      country,
      approximateGrossArea,
      approximateGrossAreaKey,
      approximateTotalBudget,
      approximateTotalBudgetKey,
      projectTitle,
      projectNumber,
      projectUsageArea,
      projectUsageType,
    } = data;
    const projectObject = {
      city: location,
      state: state,
      country: country,
      approxGrossArea:
        approximateGrossAreaKey !== '' ? approximateGrossAreaKey : null,
      approxGrossAreaValue:
        approximateGrossArea !== '' && approximateGrossArea !== undefined
          ? typeof approximateGrossArea === 'string'
            ? parseFloat(approximateGrossArea.replace(',', '.'))
            : approximateGrossArea
          : null,
      approxTotalBudget:
        approximateTotalBudgetKey !== '' &&
        approximateTotalBudgetKey !== null &&
        approximateTotalBudgetKey !== undefined
          ? approximateTotalBudgetKey.toUpperCase()
          : null,
      approxTotalBudgetValue:
        approximateTotalBudget !== '' && approximateTotalBudget !== undefined
          ? typeof approximateTotalBudget === 'string'
            ? parseFloat(approximateTotalBudget.replace(',', '.'))
            : approximateTotalBudget
          : null,
      confidential,
      description,
      name: projectTitle,
      endDate: this.state.endDate ? moment(new Date(this.state.endDate)) : null,
      projectUsageAreaId: projectUsageArea,
      projectUsageTypeId: projectUsageType,
      uniqueProjectNumber: projectNumber,
    };

    if (this.props.edit) {
      this.props.editProject(this.props.project.id, projectObject);
    } else {
      this.setState(
        {
          location: '',
          confidential: false,
          description: '',
          projectTitle: '',
          projectNumber: '',
          approxGrossArea: '',
          approxGrossAreaValue: '',
          approxTotalBudget: '',
          approxTotalBudgetValue: '',
          // projectUsage: '',
          projectUsageArea: '',
          projectUsageType: '',
          endDate: null,
        },
        () => {
          this.props.saveProject(projectObject);
        }
      );
    }
    this.props.handleClose();
    this.setState({ open: false });
  };

  handleChange = name => event => {
    if (name === 'confidential') {
      this.setState({ [name]: event.target.checked });
    } else {
      this.setState({ [name]: event.target.value });
    }
  };

  filterListOfTypes = (list, value) => {
    if (list) {
      return list.filter(type => type.parentId === Number(value));
    }
    return [];
  };

  handleDateChange = date => {
    const endDate = date.format('YYYY-MM-DD HH:mm:ss');
    this.setState({ endDate });
  };

  render() {
    return (
      <Formik
        validateOnBlur={false}
        enableReinitialize
        validationSchema={createProjectSchema}
        initialValues={{
          confidential: this.state.confidential,
          // projectUsage: this.state.projectUsage,
          projectUsageArea: this.state.projectUsageArea,
          projectUsageType: this.state.projectUsageType,
          projectTitle: this.state.projectTitle,
          projectNumber: this.state.projectNumber,
          description: this.state.description,
          location: this.state.location,
          city: this.state.city,
          state: this.state.state,
          country: this.state.country,
          approximateGrossArea: this.state.approximateGrossArea,
          approximateGrossAreaKey: this.state.approximateGrossAreaKey,
          approximateTotalBudget: this.state.approximateTotalBudget,
          approximateTotalBudgetKey: this.state.approximateTotalBudgetKey,
          search: '',
        }}
        onSubmit={data => {
          this.saveProject(data);
        }}
      >
        {({
          handleChange,
          handleBlur,
          handleReset,
          errors,
          values,
          touched,
          handleSubmit,
          setValues,
          setFieldValue,
        }) => {
          return (
            <Dialog
              maxWidth={'xs'}
              open={
                this.props.newProjectDialogOpen
                  ? this.props.newProjectDialogOpen
                  : false
              }
              onClose={this.props.handleClose}
              aria-labelledby="form-dialog-title"
            >
              <h2 className="t-primary-24 t-weight-b t-align-c u-mrg-top-57 u-mrg-bot-50">
                {this.props.edit ? 'Edit project' : 'Create new project'}
              </h2>
              <DialogContent>
                <FormControl className="w100">
                  <InputLabel htmlFor="">Project Business Area</InputLabel>
                  <NativeSelect
                    name="projectUsageArea"
                    value={values.projectUsageArea}
                    onBlur={handleBlur}
                    // onChange={this.props.edit ?  handleChange setFieldValue('projectUsageType', '') : handleChange
                    // }
                    onChange={e => {
                      handleChange(e);
                      setFieldValue('projectUsageType', '');
                    }}
                    inputProps={{
                      name: 'projectUsageArea',
                      id: 'projectUsageArea',
                      root: 'underline--c-light',
                    }}
                    error={
                      touched.projectUsageArea && errors.projectUsageArea
                        ? true
                        : false
                    }
                  >
                    <option value="" />
                    {this.props.projectUsages.projectBusinessArea &&
                      this.props.projectUsages.projectBusinessArea.map(
                        menuItem => {
                          return (
                            <option key={menuItem.id} value={menuItem.id}>
                              {menuItem.name}
                            </option>
                          );
                        }
                      )}
                  </NativeSelect>
                  {errors.projectUsageArea && touched.projectUsageArea && (
                    <FormHelperText error>
                      {errors.projectUsageArea}
                    </FormHelperText>
                  )}
                </FormControl>
                {values.projectUsageArea && (
                  <FormControl className="w100">
                    <InputLabel htmlFor="">Project Type</InputLabel>
                    <NativeSelect
                      name="projectUsageType"
                      value={values.projectUsageType}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      inputProps={{
                        name: 'projectUsageType',
                        id: 'projectUsageType',
                        root: 'underline--c-light',
                      }}
                      error={
                        touched.projectUsageType && errors.projectUsageType
                          ? true
                          : false
                      }
                    >
                      <option value="" />

                      {this.filterListOfTypes(
                        this.props.projectUsages.projectType,
                        values.projectUsageArea
                      ).map(menuItem => {
                        return (
                          <option key={menuItem.id} value={menuItem.id}>
                            {menuItem.name}
                          </option>
                        );
                      })}
                    </NativeSelect>
                    {errors.projectUsageType && touched.projectUsageType && (
                      <FormHelperText error>
                        {errors.projectUsageType}
                      </FormHelperText>
                    )}
                  </FormControl>
                )}

                <TextField
                  margin="dense"
                  id="project-title"
                  label="Project Title"
                  type="text"
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.projectTitle}
                  InputLabelProps={{
                    className: 'label--c-light',
                  }}
                  InputProps={{
                    name: 'projectTitle',
                    className: 'underline--c-light',
                  }}
                  error={!!(errors.projectTitle && touched.projectTitle)}
                  helperText={
                    errors.projectTitle && touched.projectTitle
                      ? errors.projectTitle
                      : false
                  }
                />
                <TextField
                  margin="dense"
                  id="project-number"
                  label="Project Number"
                  type="text"
                  fullWidth
                  onChange={handleChange}
                  value={values.projectNumber}
                  InputLabelProps={{
                    className: 'label--c-light',
                  }}
                  InputProps={{
                    name: 'projectNumber',
                    className: 'underline--c-light',
                  }}
                  error={!!(errors.projectNumber && touched.projectNumber)}
                  helperText={
                    errors.projectNumber && touched.projectNumber
                      ? errors.projectNumber
                      : false
                  }
                />
                <TextField
                  margin="dense"
                  id="project-description"
                  label="Description"
                  type="text"
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                  InputLabelProps={{
                    className: 'label--c-light',
                  }}
                  InputProps={{
                    name: 'description',
                    className: 'underline--c-light',
                  }}
                  error={
                    touched.description && errors.description ? true : false
                  }
                  helperText={
                    errors.description && touched.description
                      ? errors.description
                      : false
                  }
                />
                <GoogleMapLoader
                  params={{
                    key: GOOGLE_API_KEY,
                    libraries: 'places,geocode',
                    language: 'en',
                  }}
                  render={googleMaps =>
                    googleMaps ? (
                      <GooglePlacesSuggest
                        googleMaps={googleMaps}
                        autocompletionRequest={{
                          input: this.state.city
                            ? this.state.city
                            : values.search,
                          types: ['(cities)'],
                        }}
                        onSelectSuggest={this.handleSelectSuggest(
                          setValues,
                          values
                        )}
                        textNoResults="No results" // null or "" if you want to disable the no results item
                        customRender={prediction => (
                          <div className="customWrapper">
                            {prediction ? prediction.description : 'No results'}
                          </div>
                        )}
                      >
                        <TextField
                          margin="dense"
                          id="city"
                          label="City"
                          type="text"
                          fullWidth
                          multiline
                          value={values.location}
                          onChange={this.handleInputChange(setValues, values)}
                          InputLabelProps={{
                            className: 'label--c-light',
                          }}
                          InputProps={{
                            name: 'location',
                            className: 'underline--c-light',
                          }}
                          error={!!(errors.location && touched.location)}
                          helperText={
                            errors.location && touched.location
                              ? errors.location
                              : false
                          }
                        />
                      </GooglePlacesSuggest>
                    ) : (
                      <TextField
                        margin="dense"
                        id="city"
                        label="City"
                        type="text"
                        fullWidth
                        multiline
                        value={values.location}
                        onChange={this.handleInputChange(setValues, values)}
                        InputLabelProps={{
                          className: 'label--c-light',
                        }}
                        InputProps={{
                          name: 'location',
                          className: 'underline--c-light',
                        }}
                        error={!!(errors.location && touched.location)}
                        helperText={
                          errors.location && touched.location
                            ? errors.location
                            : false
                        }
                      />
                    )
                  }
                />
                <TextField
                  margin="dense"
                  id="state"
                  label="County/State"
                  type="text"
                  fullWidth
                  disabled={true}
                  value={values.state ? values.state : ''}
                  onChange={this.handleInputChange(setValues, values)}
                  InputLabelProps={{
                    className: 'label--c-light',
                  }}
                  InputProps={{
                    name: 'state',
                    className: 'underline--c-light',
                  }}
                  error={!!(errors.state && touched.state)}
                  helperText={
                    errors.state && touched.state ? errors.state : false
                  }
                />
                <TextField
                  margin="dense"
                  id="country"
                  label="Country"
                  type="text"
                  fullWidth
                  disabled={true}
                  value={values.country}
                  onChange={this.handleInputChange(setValues, values)}
                  InputLabelProps={{
                    className: 'label--c-light',
                  }}
                  InputProps={{
                    name: 'country',
                    className: 'underline--c-light',
                  }}
                  error={!!(errors.country && touched.country)}
                  helperText={
                    errors.country && touched.country ? errors.country : false
                  }
                />
                <Grid
                  container
                  spacing={8}
                  style={{
                    alignItems: errors.approximateGrossArea
                      ? 'center'
                      : 'flex-end',
                  }}
                >
                  <Grid item xs={12} md={8}>
                    <TextField
                      margin="dense"
                      style={{ width: '95%' }}
                      id="approximate-gross-area"
                      label="Approximate gross area"
                      type="text"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.approximateGrossArea}
                      InputLabelProps={{
                        className: 'label--c-light',
                      }}
                      InputProps={{
                        name: 'approximateGrossArea',
                        className: 'underline--c-light',
                      }}
                      error={
                        touched.approximateGrossArea &&
                        errors.approximateGrossArea
                          ? true
                          : false
                      }
                      helperText={
                        errors.approximateGrossArea &&
                        touched.approximateGrossArea
                          ? errors.approximateGrossArea
                          : false
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4} style={{ marginBottom: '4px' }}>
                    <FormControl style={{ width: '100%' }}>
                      <NativeSelect
                        name="approximateGrossAreaKey"
                        value={values.approximateGrossAreaKey}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        inputProps={{
                          name: 'approximateGrossAreaKey',
                          id: 'approximateGrossAreaKey',
                          root: 'underline--c-light',
                        }}
                        error={
                          touched.approximateGrossAreaKey &&
                          errors.approximateGrossAreaKey
                            ? true
                            : false
                        }
                        helperText={
                          errors.approximateGrossAreaKey &&
                          touched.approximateGrossAreaKey
                            ? errors.approximateGrossAreaKey
                            : false
                        }
                      >
                        <option value="" />
                        {unit &&
                          unit.map(menuItem => {
                            return (
                              <option key={menuItem.id} value={menuItem.id}>
                                {menuItem.name}
                              </option>
                            );
                          })}
                      </NativeSelect>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={8}
                  style={{
                    alignItems: errors.approximateTotalBudget
                      ? 'center'
                      : 'flex-end',
                  }}
                >
                  <Grid item xs={12} md={8}>
                    <TextField
                      margin="dense"
                      style={{ width: '95%' }}
                      id="approximate-total-budget"
                      label="Approximate total budget"
                      type="text"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.approximateTotalBudget}
                      InputLabelProps={{
                        className: 'label--c-light',
                      }}
                      InputProps={{
                        name: 'approximateTotalBudget',
                        className: 'underline--c-light',
                      }}
                      error={
                        touched.approximateTotalBudget &&
                        errors.approximateTotalBudget
                          ? true
                          : false
                      }
                      helperText={
                        errors.approximateTotalBudget &&
                        touched.approximateTotalBudget
                          ? errors.approximateTotalBudget
                          : false
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4} style={{ marginBottom: '4px' }}>
                    <FormControl style={{ width: '100%' }}>
                      <NativeSelect
                        name="approximateTotalBudgetKey"
                        value={values.approximateTotalBudgetKey}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        inputProps={{
                          name: 'approximateTotalBudgetKey',
                          id: 'approximateTotalBudgetKey',
                          root: 'underline--c-light',
                        }}
                        error={
                          touched.approximateTotalBudgetKey &&
                          errors.approximateTotalBudgetKey
                            ? true
                            : false
                        }
                        helperText={
                          errors.approximateGrossAreaKey &&
                          touched.approximateGrossAreaKey
                            ? errors.approximateGrossAreaKey
                            : false
                        }
                      >
                        <option value="" />
                        {currency &&
                          currency.map(menuItem => {
                            return (
                              <option key={menuItem.id} value={menuItem.id}>
                                {menuItem.name}
                              </option>
                            );
                          })}
                      </NativeSelect>
                    </FormControl>
                  </Grid>
                </Grid>
                <DatePicker
                  style={{ width: '100% !important;' }}
                  leftArrowIcon={<KeyboardArrowLeft />}
                  rightArrowIcon={<KeyboardArrowRight />}
                  handleDateChange={this.handleDateChange}
                  selectedDate={this.state.endDate}
                  label={'End date'}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="confidential"
                      checked={values.confidential}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  }
                  label="Confidential"
                />
              </DialogContent>

              <DialogActions>
                <Button
                  classes={{
                    root: 't-primary-16 c-blue-2-light t-weight-b',
                  }}
                  onClick={e => {
                    this.props.handleClose();
                    handleReset(e);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  classes={{
                    root: 't-primary-16 c-s-blue',
                  }}
                  onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                >
                  {this.props.edit ? 'Save' : 'Create'}
                </Button>
              </DialogActions>
            </Dialog>
          );
        }}
      </Formik>
    );
  }
}

const mapStateToProps = store => {
  return {
    projectUsages: store.projects.projectUsages,
  };
};
const mapDispatchToProps = dispatch => ({
  editProject: (projectId, projectObject) => {
    dispatch(editProject(projectId, projectObject));
  },
  saveProject: projectObject => {
    dispatch(saveProject(projectObject));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(NewProjectDialog);
